export default class Bootstrap {

    static tooltips() {
        $('[data-toggle="tooltip"]').tooltip();
    }

}
